import { coreGet, coreMutate } from "./api-client";

export interface RoleNotificationSmtpStatus {
  readonly endpoint: {
    readonly provider: "AWS_SES";
    readonly region: "us-east-1";
    readonly port: 587;
    readonly tlsMode: "STARTTLS";
    readonly fromAddressMasked: string;
    readonly salesRecipientMasked: string;
    readonly sourcingRecipientMasked: string;
  };
  readonly usernameConfigured: boolean;
  readonly passwordConfigured: boolean;
  readonly credentialsConfigured: boolean;
  readonly credentialSetConfirmed: boolean;
  readonly policyBound: boolean;
  readonly ready: boolean;
  readonly sendingReleased: boolean;
  readonly lastRotatedAt: string | null;
}

export function loadRoleNotificationSmtpStatus(): Promise<RoleNotificationSmtpStatus> {
  return coreGet<RoleNotificationSmtpStatus>(
    "/integrations/role-notification/smtp",
  );
}

export function saveRoleNotificationSmtpCredentials(
  smtpUsername: string,
  smtpPassword: string,
): Promise<RoleNotificationSmtpStatus> {
  return coreMutate<RoleNotificationSmtpStatus>(
    "/integrations/role-notification/smtp/credentials",
    "POST",
    { smtpUsername, smtpPassword },
  );
}
